module.exports = __webpack_public_path__ + "static/media/operation@3x.9607e2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/operation@3x.png
// module id = 1960
// module chunks = 6